import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import userModel, { IUser } from './userModel';
import addressModel, { IAddress } from './addressModel';
import employeeProfileItemModel, { IEmployeeProfileItem } from './employeeProfileItemModel';
import phonable, { IPhonable } from './phonable';
import model from './model';
import person, { IPerson } from './person';
import { IModelSet } from '../modelSet';

export interface IEmployee extends IModel, IPerson, IPhonable {
	accountingId?: string;
	emailAddress?: string;
	salesCommissionPercent?: number;
	inactive?: boolean;
	addresses: IModelSet<IAddress>;
	profileItems: IModelSet<IEmployeeProfileItem>;
	orgTitleKey?: string;
	orgDepartmentKey?: string;
	user: IUser,
	userName?: string;
	getProfileValue(name: string, defaultValue?: string): string;
	setProfileValue(name: string, value: string): void;
}

const employeeFactory = modelFactory.createFactory<IEmployee>('Employee', _.assign({}, model, person, phonable, {
	accountingId: {
		setFilters: valueFilters.clean
	},
	emailAddress: { // override person to validate email
		setFilters: valueFilters.clean,
		rules: validator.email() // don't allow undefined
	},
	salesCommissionPercent: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber
	},
	inactive: {
		setFilters: [valueFilters.clean, valueFilters.toBoolean],
		defaultValue: false
	},
	addresses: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(addressModel),
		rules: validator.validModel((addressModel as any).rules())
	},
	profileItems: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(employeeProfileItemModel),
		rules: validator.validModel((employeeProfileItemModel as any).rules())
	},
	orgTitleKey: {
		setFilters: valueFilters.clean
	},
	orgDepartmentKey: {
		setFilters: valueFilters.clean
	},
	user: {
		setFilters: valueFilters.toModel(userModel),
		defaultValue: {},
		rules: validator.validModel((userModel as any).rules())
	},
	userName: {
		writable: false,
		nonSerialized: true
	},
	_get_userName: function () {
		return this.user.userName;
	},
	formattedModules: {
		writable: false,
		nonSerialized: true
	},
	_get_formattedModules: function () {
		return this.user.claims.toDocumentArray().join(', ');
	},
	getProfileValue: function (name, defaultValue) {
		const item = _.find(this.profileItems, { name });

		return item ? item.value : defaultValue;
	},
	setProfileValue: function (name, value) {
		const item = _.find(this.profileItems, { name });

		if (item && (typeof value === undefined || value === '')) {
			this.profileItems.delete(item.key);
		}
		else if (!item) {
			this.profileItems.add({ name: name, value: value });
		}
		else {
			item.value = value;
		}
	}
}));

export default employeeFactory;